import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { startLoading, doneLoading } from '../utils/loading'

export default function RenderImg() {
  const location = useLocation()
  const [queryString, setQueryString] = useState()

  useEffect(() => {
    let qstr = location.search.substring(1)
    // let qstr = sessionStorage.getItem('param')?.substring(1)
    setQueryString(qstr)
  }, [])

  return (
    <>
      <div>{queryString ? <img src={queryString}></img> : <h1>Error page.</h1>}</div>
    </>
  )
}
